import {importKakaoSdk} from './importKakaoSdk.function';
import {importSandboxKakaoSdk} from './importSandboxKakaoSdk.function';

export function setKakaoAccessToken(
  useSandboxSdk: boolean,
  accessToken: string | null
): void {
  (useSandboxSdk ? importSandboxKakaoSdk : importKakaoSdk)()
    .then(() => {
      (window as any).Kakao.Auth.setAccessToken(accessToken);
    })
    .catch(() => {
      console.log('importKakaoSdk 실패');
    });
}
